export const VimplayData = {
  vimplay1: {
    redirectUrl: "/casino/vimplayvimplay-techno-roulette",
    imgUrl: "./images/vimplay/texhnoroulette.jpg",
    name: "TECHNO ROULETTE",
  },
  vimplay2: {
    redirectUrl: "/casino/vimplayvimplay-royal-roulette",
    imgUrl: "./images/vimplay/RoyalRoulette.jpg",
    name: "ROYAL ROULETTE",
  },
  vimplay3: {
    redirectUrl: "/casino/vimplayvimplay-replay-roulette",
    imgUrl: "./images/vimplay/ReplayRoullete.jpg",
    name: "REPLAY ROULETTE",
  },
  vimplay4: {
    redirectUrl: "/casino/vimplayvimplay-cosmic-roulette",
    imgUrl: "./images/vimplay/cosmicroulette.jpg",
    name: "COSMIC ROULETTE",
  },
  vimplay5: {
    redirectUrl: "/casino/vimplayvimplay-rouletto",
    imgUrl: "./images/vimplay/rouletto.jpg",
    name: "ROULETTO",
  },
  vimplay6: {
    redirectUrl: "/casino/vimplayvimplay-bombrunner",
    imgUrl: "./images/vimplay/BombRun.jpg",
    name: "BOMB_RUNNER",
  },
  vimplay7: {
    redirectUrl: "/casino/vimplayvimplay-wishingwell",
    imgUrl: "./images/vimplay/Wishingwell.jpg",
    name: " WISHING_WELL",
  },
  vimplay8: {
    redirectUrl: "/casino/vimplayvimplay-crash-kick",
    imgUrl: "./images/vimplay/crashkick.jpg",
    name: "CRASH KICK",
  },
  vimplay9: {
    redirectUrl: "/casino/vimplayvimplay-lottoluck",
    imgUrl: "./images/vimplay/lottoluck.jpg",
    name: "LOTTO_LUCK",
  },
  vimplay10: {
    redirectUrl: "/casino/vimplayvimplay-dragontap",
    imgUrl: "./images/vimplay/dragontap.jpg",
    name: "DRAGON_TAP",
  },
  vimplay11: {
    redirectUrl: "/casino/vimplayvimplay-hotorcold",
    imgUrl: "./images/vimplay/HOTORCOLD.webp",
    name: "HOT_OR_COLD",
  },
  vimplay12: {
    redirectUrl: "/casino/vimplayvimplay-fate-flip",
    imgUrl: "./images/vimplay/FATEFLIP.webp",
    name: "FATE FLIP",
  },
  vimplay13: {
    redirectUrl: "/casino/vimplayvimplay-spinnywinny",
    imgUrl: "./images/vimplay/Spinnywinny.jpg",
    name: "SPINNY_WINNY",
  },
  vimplay14: {
    redirectUrl: "/casino/vimplayvimplay-tossboss",
    imgUrl: "./images/vimplay/TOSSBOSS.webp",
    name: "TOSS_BOSS",
  },
  vimplay15: {
    redirectUrl: "/casino/vimplayvimplay-paradice",
    imgUrl: "./images/vimplay/paradice.jpg",
    name: "PARADICE",
  },
  vimplay16: {
    redirectUrl: "/casino/vimplayvimplay-piratemines",
    imgUrl: "./images/vimplay/piratemines.jpg",
    name: "PIRATE_MINES",
  },
  vimplay17: {
    redirectUrl: "/casino/vimplayvimplay-space-raiders",
    imgUrl: "./images/vimplay/spaceraiders.jpg",
    name: "Space Raiders",
  },
  vimplay18: {
    redirectUrl: "/casino/vimplayvimplay-aladdin",
    imgUrl: "./images/vimplay/ALADDIN.webp",
    name: "ALADDIN",
  },
  vimplay19: {
    redirectUrl: "/casino/vimplayvimplay-tinyroulette",
    imgUrl: "./images/vimplay/tiny_Roulette.jpg",
    name: "TINY_ROULETTE",
  },
  vimplay20: {
    redirectUrl: "/casino/vimplayvimplay-luckyline",
    imgUrl: "./images/vimplay/luckyline.jpg",
    name: "LUCKY_LINE",
  },
  vimplay21: {
    redirectUrl: "/casino/vimplayvimplay-diamondmine",
    imgUrl: "./images/vimplay/DiamondMine.jpg",
    name: "DIAMOND_MINE",
  },
  vimplay22: {
    redirectUrl: "/casino/vimplayvimplay-aquakeno",
    imgUrl: "./images/vimplay/Aquakeno.jpg",
    name: "AQUA_KENO",
  },
  vimplay23: {
    redirectUrl: "/casino/vimplayvimplay-aladdin",
    imgUrl: "./images/vimplay/magical.jpg",
    name: "Magic Aladdin",
  },
  vimplay24: {
    redirectUrl: "/casino/vimplayvimplay-sakuraroulette",
    imgUrl: "./images/vimplay/Sakura.jpg",
    name: "Sakura Roulette",
  },
  vimplay24: {
    redirectUrl: "/casino/vimplayvimplay-shaktimaan",
    imgUrl: "./images/vimplay/Shaktiman.jpg",
    name: "Shaktimaan",
  },
  vimplay25: {
    redirectUrl: "/casino/vimplayvimplay-monacoroulette",
    imgUrl: "./images/vimplay/MonacoRoulette.jpg",
    name: "Monaco Roulette",
  },
  vimplay26: {
    redirectUrl: "/casino/vimplayvimplay-arabicroulette",
    imgUrl: "./images/vimplay/Arabicroulette.jpg",
    name: "Arabic Roulette",
  },
};
